<template>
    
    <v-row align="center" class="my-16 rounded" style="background-color: #00B1C3; min-width: 400px">
        <v-col cols="12" md="2" align="center">
            <div>
                <h2 style="color: white;">BENEFITS</h2>
            </div>
        </v-col>

        <v-col>
            <v-card elevation="2">
                <v-card-text>
                    <v-row
                        class="my-4"
                        align="center"
                        justify="center"
                    >
                        <h2>Benefits</h2>
                    </v-row>
                    <v-row
                        align="start"
                        justify="center"
                        class="mb-6"
                    >
                        <v-col cols="12" md="4">
                            <v-card
                                class="mx-auto"
                                max-width="300"
                                tile
                            >
                                <v-list dense>
                                    <v-list-item
                                    v-for="(item, i) in listOneItems"
                                    :key="i"
                                    >
                                        <v-list-item-icon>
                                            <v-icon color="#00B1C3">{{ item.icon }}</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title>{{ item.text }}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-card
                                class="mx-auto"
                                max-width="300"
                                tile
                            >
                                <v-list dense>
                                    <v-list-item
                                    v-for="(item, i) in listTwoItems"
                                    :key="i"
                                    >
                                        <v-list-item-icon>
                                            <v-icon color="#00B1C3">{{ item.icon }}</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title>{{ item.text }}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card-text>
                
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: 'BenefitsCard',
    data: () => ({
        selectedItem: 0,
        listOneItems: [
            { text: '401K From Day 1', icon: "mdi-bullseye-arrow" },
            { text: 'Benefits After 60 Days', icon: "mdi-bullseye-arrow" },
            { text: 'Medical, Dental, and Vision Insurance', icon: "mdi-bullseye-arrow" },
            { text: 'Short and Long Term Disability', icon: "mdi-bullseye-arrow" },
            { text: 'Life Insurance', icon: "mdi-bullseye-arrow" }
        ],
        listTwoItems: [
            { text: 'Adoption and Fertility Assistance', icon: "mdi-bullseye-arrow" },
            { text: 'Tuition Reimbursement', icon: "mdi-bullseye-arrow" },
            { text: 'Teammate Compassion Fund', icon: "mdi-bullseye-arrow" },
            { text: 'Pet Insurance', icon: "mdi-bullseye-arrow" },
        ]
    }),
}
</script>